import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { IIPCountryRangeManager } from './IIPCountryRangeManager';
import { GetRangesModel } from './Models/GetRangesModel';
import { IPCountryRange } from './Models/IPCountryRange';
import { ResultModel } from './ResultModel';

export class IPCountryRangeManager implements IIPCountryRangeManager {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;
    private readonly errorMsg: string = 'Error in IP Country Range manager request';
    private readonly basePath: string = '/tools/throttling/ranges';


    async getCountryCode(address: string) {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/' + encodeURIComponent(address),
            method: HttpMethod.GET
        });

        var res = await this.manager
            .get<ResultModel<string>>(req);
        return res.res;
    }

    async getRangesCount(model: GetRangesModel) {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/count',
            method: HttpMethod.POST
        }, model);

        var res = await this.manager
            .get<ResultModel<number>>(req);
        return res.res;
    }

    getRanges(model: GetRangesModel): Promise<IPCountryRange[]> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath,
            method: HttpMethod.POST
        }, model);

        return this.manager
            .get<any[]>(req)
            .then((res) => {
                return res.map((v, idx, arr) => {
                    return new IPCountryRange(v);
                });
            });
    }

    add(model: IPCountryRange): Promise<IPCountryRange> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath,
            method: HttpMethod.PUT
        }, model);

        return this.manager
            .get<any>(req)
            .then((res) => {
                return new IPCountryRange(res);
            });
    }

    async addMany(models: IPCountryRange[]) {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/many',
            method: HttpMethod.PUT
        }, models);

        var res = await this.manager
            .send(req);

        if (!res.ok) {
            console.log(this.errorMsg, req, res);
            throw new Error(this.errorMsg);
        }
    }

    async delete(id: string) {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/' + encodeURIComponent(id),
            method: HttpMethod.DELETE
        });

        
        var res = await this.manager.send(req);

        if (!res.ok) {
            console.log(this.errorMsg, req, res);
            throw new Error(this.errorMsg);
        }
    }
}